import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import { store } from './core.Store';
import { Game } from '../_game/init';

class Application {
   constructor() {
		const root = ReactDOM.createRoot(
			document.getElementById('root') as HTMLElement
		);
	 
		root.render( 
			<Provider store={store}>
  			<Game /> 
			</Provider>
		);
	 }

	 reloadApp() {
		window.location.reload();
	 }
}

export default Application;